import {
  endOfMonth,
  format,
  isSameMonth,
  isSameQuarter,
  startOfMonth,
  subDays,
} from 'date-fns';
import { getUTCDate } from './helpers';
import {
  ClientWarehouse,
  ClientWarehouseBE,
  CountryThreshold,
  Evaluation,
  NormalizedEvaluation,
  PeriodType,
  SellerFilingReport,
  NormalizedSellerFilingReport,
} from './types';

export const normalizeCountryThresholdFE = (item: CountryThreshold) => ({
  ...item,
  threshold: {
    ...item.threshold,
    value: item.threshold.value / 100,
  },
});
export const normalizeClientWarehousesFE = (
  item: ClientWarehouseBE
): ClientWarehouse => ({
  ...item,
  active_from: new Date(item.active_from),
});
export const normalizeDateBE = (date: Date) =>
  format(date, "yyyy-MM-dd'T'HH:mm:ss+00:00");

export const normalizeDateFE = (iso: string) => {
  return getUTCDate(new Date(iso));
};

/**
 * All data-provision deadlines on the customer portal are shown one day before
 * the raw backend `deadline_date` — the 6th of the month instead of the 7th
 * (VS-8898). The backend still emits the 7th, so we subtract a day on the
 * frontend for display. Gated behind the `vs8898DeadlineDate` flag: when it is
 * off we keep the original deadline.
 */
export const getDataProvisionDeadline = (
  deadlineDate: string,
  isEnabled: boolean | undefined
): Date => {
  const date = normalizeDateFE(deadlineDate);
  return isEnabled ? subDays(date, 1) : date;
};

export const normalizeFilingReport =
  (completed_filing: boolean) =>
  (r: SellerFilingReport): NormalizedSellerFilingReport => {
    return {
      ...r,
      completed_filing,
    };
  };

const getEvaluationDate = (v: string) => {
  return new Date(v.split('.').reverse().join('-'));
};

export const normalizeEvaluation = (e: Evaluation): NormalizedEvaluation => {
  const parts = e.period.split('-').map((v) => v.trim());

  const startDate = startOfMonth(getEvaluationDate(parts[0]));
  const endDate = endOfMonth(getEvaluationDate(parts[1]));

  let type: PeriodType = 'month';
  if (isSameMonth(startDate, endDate)) {
    type = 'month';
  } else if (isSameQuarter(startDate, endDate)) {
    type = 'quarter';
  }

  return {
    ...e,
    startDate,
    endDate,
    type,
  };
};
